import React from "react";
import TutorsList from "../features/showTutors/components/TutorsList";

const FilterTutors: React.FC = () => {
  return (
    <div>
      <TutorsList />
    </div>
  );
};

export default FilterTutors;
